<div class="brand-section">
    <div class="container">
        <app-breadcrumb [breadcrumbs]="currentBreadcrumb"></app-breadcrumb>
        <div class="row">
            <div id="content" class="col">
                <h1>Find Your Favorite Brand</h1>
                <div class="brand-index">
                    <strong>Brand Index:</strong>
                    <div class="d-flex align-items-center flex-wrap">
                        <a href="javascript:void" *ngFor="let letter of nameArray"
                            (click)="scrollToSection(letter)">{{letter }}</a>
                    </div>
                </div>
                <div *ngFor="let letter of nameArray">
                    <h2 id="{{ letter }}">{{ letter }}</h2>
                    <div class="row mb-3">
                        <div class="col-sm-2" *ngFor="let brand of groupBrands[letter]">
                            <!-- One link for the whole card: the target shows on hover and the
                                 card can be opened in a new tab. The image and name used to be
                                 wrapped in <a [href]=""> (i.e. the current page), which the
                                 click handler then had to fight. -->
                            <a class="product-thumb" [routerLink]="['/brand', brand.slug]">
                                <div class="image">
                                    <img [src]="brand.imageUrl" [alt]="brand.name" class="img-fluid" />
                                </div>
                                <div class="description">
                                    <h4>{{ brand.name }}</h4>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>